// extracted by mini-css-extract-plugin
export default {"modules":"McPieChart_modules__P7fTB","navbar":"McPieChart_navbar__OUoaN","navbar0":"McPieChart_navbar0__8v4wx","view":"McPieChart_view__3oF9C","module":"McPieChart_module__YE+xO"};